import React, { useState } from "react";
import MagazineTable from "../../components/magazine/MagazineTable";
import DonationTable from "../../components/magazine/DonationTable";
import ContactTable from "../../components/magazine/ContactTable";
import MagazineSurveyTable from "../../components/magazine/MagazineSurveyTable";
import HeroSectionTable from "../../components/magazine/HeroSectionTable";

const MagazineList = ({
  activeTab,
  handleItemClick,
  handleDeleteMagazine,
  list,
  donationList,
  loading,
  error,
  contactUsList,
  heroSectionList,
  magazineSurveyList,
  handleDeleteMagazineSurvey,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // if (loading) {
  //   return <div className="text-center p-5">Loading...</div>;
  // }

  if (error) {
    return <div className="text-center p-5 text-danger">{error}</div>;
  }

  return (
    <div className="col-md-9 col-lg-10 p-3">
      {activeTab === "magazine" && (
        <div className="row">
          <div className="col-12 mb-4">
            <MagazineTable
              list={list}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              handleItemClick={handleItemClick}
              handleDeleteMagazine={handleDeleteMagazine}
            />
          </div>
        </div>
      )}

      {activeTab === "donation" && (
        <div className="row">
          <div className="col-12 mb-4">
            <DonationTable
              donationList={donationList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              handleItemClick={handleItemClick}
            />
          </div>
        </div>
      )}

      {activeTab === "contact" && (
        <div className="row">
          <div className="col-12 mb-4">
            <ContactTable
              contactUsList={contactUsList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
              handleItemClick={handleItemClick}
            />
          </div>
        </div>
      )}

      {activeTab === "create-magazine-survey" && (
        <div className="row">
          <div className="col-12 mb-4">
            <MagazineSurveyTable
              magazineSurveyList={magazineSurveyList}
              handleItemClick={handleItemClick}
              handleDeleteMagazineSurvey={handleDeleteMagazineSurvey}
            />
          </div>
        </div>
      )}

      {activeTab === "hero-section-management" && (
        <div className="row">
          <div className="col-12 mb-4">
            <HeroSectionTable
              heroSectionList={heroSectionList}
              handleItemClick={handleItemClick}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MagazineList;
